import React from 'react';
import { AdsCustomMessage as AdsCustomChatMessage } from '../ad-preview';
import { MessageWithActions } from './message-with-actions';
import {
  customMessageProps, ICustomMessageContent, CustomMessageType, TextAdsCustomMessage, ProdAdsCustomMessage,
} from './message-types';

export const AdMessageWithActions: React.FunctionComponent<customMessageProps> = (props) => {
  const { message } = props;
  const customMessage = JSON.parse(message.content) as ICustomMessageContent;

  let adContent;

  switch (customMessage.type) {
    case CustomMessageType.TextAds:
      // eslint-disable-next-line no-case-declarations
      const textAdsMessage = customMessage as TextAdsCustomMessage;
      // eslint-disable-next-line no-case-declarations
      const shownTextAds = textAdsMessage.ads.map((ad) => ({
        longHeadline: ad?.title,
        description: ad?.description,
        displayUrl: ad?.displayUrl,
        finalUrl: ad?.url,
      }));
      adContent = (
        <AdsCustomChatMessage
          shownAdsType="text"
          shownAds={shownTextAds}
          shownResponse={customMessage.response}
        />
      );
      break;
    case CustomMessageType.ProdAds:
      // eslint-disable-next-line no-case-declarations
      const prodAdsMessage = customMessage as ProdAdsCustomMessage;
      // eslint-disable-next-line no-case-declarations
      const showProdAds = prodAdsMessage.ads.map((ad) => ({
        longHeadline: ad?.offer?.itemOffered?.name,
        description: ad?.offer?.itemOffered?.description,
        displayUrl: ad?.offer?.url,
        finalUrl: ad?.offer?.url,
        lowPrice: ad?.offer?.lowPrice,
        price: ad?.offer?.price,
        priceCurrencySymbol: ad?.offer?.priceCurrencySymbol,
        imageSrc: ad?.offer?.itemOffered?.image?.contentUrl,
        shippingDescription: ad?.shippingInfo?.description,
      }));
      adContent = (
        <AdsCustomChatMessage
          shownAdsType="prod"
          shownAds={showProdAds}
          shownResponse={customMessage.response}
        />
      );
      break;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      adContent = <></>;
      break;
  }

  return <MessageWithActions message={message} messageContent={adContent} customClassName="ad-custom-message-container" />;
};
